import React from 'react';
import './Section.scss';


// Lexys imports
import profPic from '../../assets/images/lexy3.png';


// this is how we're setting the style for our image
// we use background instead of the image tag
// <img src={profPic} alt="Profile Picture"></img> */
var ppicStyle = {
    backgroundImage: `url(${profPic})`,
}


function RenderPpic() {
    console.log("Were gonna render the profpic");
    return (
        <>
            <div class="ppic" style={ppicStyle}></div>
        </>
    )
}


class Section extends React.Component {
    render() {
        return (
            <div className="section-wrapper">
                <div className={!this.props.extraClass ? 'section' : ('section ' + this.props.extraClass)}>
                    <h2 className="section-header">
                        <div className="section-header-mlan">
                        {React.cloneElement(this.props.headerIcon, { classes: { root: 'section-header-icon' } })}
                        {this.props.sectionHeader}
                        </div>

                        {this.props.sectionHeader === "About" ? <RenderPpic /> : null }
                    </h2>
                    <div className="section-content">
                        {this.props.children}
                    </div>
                </div>
            </div>
        );
    }
}

export default Section;